import React from "react";

export const WebinarBackIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" role="presentation" width="5" height="9" viewBox="0 0 5 9" fill="none">
        <path d="M3.91457 0.189076C4.16667 -0.0630252 4.55882 -0.0630252 4.81092 0.189076C5.06303 0.441176 5.06303 0.833333 4.81092 1.08543L1.53361 4.41877L4.81092 7.7521C5.06303 8.0042 5.06303 8.39636 4.81092 8.64846C4.69888 8.7605 4.53081 8.81653 4.36274 8.81653C4.19468 8.81653 4.02661 8.7605 3.91457 8.62045L0.189076 4.83894C-0.063025 4.58683 -0.063025 4.19468 0.189076 3.94258L3.91457 0.189076Z" fill="#595959" />
    </svg>

);